// "ap_subject_tests": [{ type: 'ap', score: 80, subject: 'Mathematics' }],
//   "ib_subject_tests": null,
//   "a_level_subject_tests": null,

export const SUBJECT_TESTING_TYPES = ['ap'];
const isSubjectTests = (type: string) => SUBJECT_TESTING_TYPES.includes(type);

interface StandardItem {
  type: string;
  score: number;
  subject: string;
}

export default class ApTestsConverter {
  static is = isSubjectTests;
  static isValid = (item: StandardItem) => {
    return item.score > 0 || Boolean(item.subject);
  };

  static toArray(resume: Record<string, any>) {
    const items: StandardItem[] = [];
    SUBJECT_TESTING_TYPES.forEach((type) => {
      const subjectTests = resume['ap_subject_tests'] || [];
      subjectTests.forEach((subjectTest) => {
        const { score, subject } = subjectTest;
        items.push({ type, score, subject });
      });
    });
    return items;
  }

  static toValidArray(resume: Record<string, any>) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }

  static toObject(items: StandardItem[]) {
    const results = items.map((item) => {
      const { score, subject } = item;
      return { score: score || 0, subject: subject || '' };
    });

    return {
      ap_subject_tests: results,
    };
  }

  static defaults() {
    return {
      ap_subject_tests: [],
    };
  }
}
